/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_EmptyInputs */

const en_us2_clubs_empty = /** @type {(inputs: Clubs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're not in any club yet.`)
};

const pt_br2_clubs_empty = /** @type {(inputs: Clubs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você ainda não está em nenhum clube.`)
};

const es_419_clubs_empty = /** @type {(inputs: Clubs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no estás en ningún club.`)
};

const pt_pt2_clubs_empty = /** @type {(inputs: Clubs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não estás em nenhum clube.`)
};

const fr_fr2_clubs_empty = /** @type {(inputs: Clubs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu n'es encore dans aucun club.`)
};

const de_de2_clubs_empty = /** @type {(inputs: Clubs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist noch in keinem Club.`)
};

const it_it2_clubs_empty = /** @type {(inputs: Clubs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non sei ancora in nessun club.`)
};

/**
* | output |
* | --- |
* | "You're not in any club yet." |
*
* @param {Clubs_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_empty = /** @type {((inputs?: Clubs_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_empty(inputs)
	if (locale === "es-419") return es_419_clubs_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_empty(inputs)
	if (locale === "de-DE") return de_de2_clubs_empty(inputs)
	if (locale === "it-IT") return it_it2_clubs_empty(inputs)
	return en_us2_clubs_empty(inputs)
});
export { clubs_empty as "clubs.empty" }